module.exports = __webpack_public_path__ + "static/media/animation.a8052f9a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader/animation.gif
// module id = 601
// module chunks = 0